export default __webpack_public_path__ + "static/media/gallery_16.6c009b52.jpg";